<template>
	<div class="report_compliance">
		<base-card title="血压管理">
			<card :list="pressure"></card>
		</base-card>
		<base-card title="血糖管理" class="mt-28">
			<!-- <template #action>
				<div class="base_card_label">本周平均随机血糖</div>
			</template> -->
			<card :list="sugar"></card>
		</base-card>
		<base-card title="" class="p-20 mt-28">
			<template #action>
				<div class="report_calendar_header">
					<div class="title">用药依从性</div>
					<div class="tag_row">
						<div class="tag prmary-tag">已服药</div>
						<div class="tag warry-tag">漏服药</div>
						<div class="tag error-tag">未标记</div>
					</div>
				</div>
			</template>
			<div class="report_calendar_content">
				<van-calendar
					v-if="detail.id"
					readonly
					:show-title="false"
					:poppable="false"
					:show-mark="false"
					:show-confirm="false"
					:min-date="minDate"
					:max-date="maxDate"
					:formatter="formatter"
					first-day-of-week="1"
				>
				</van-calendar>
				<div class="calendar_text"
					>已服药 <span class="text-primary">{{ detail.takeMedicine }}</span> 天，漏服药
					<span style="color:#F7BA1E">{{ detail.notTakeMedicine }}</span> 天，未标记
					<span class="text-danger">{{ detail.unmark }}</span> 天</div
				>
			</div>
		</base-card>
	</div>
</template>
<script>
import card from './report-month-card.vue'
export default {
    name: 'reportCompliance',
    components: { card },
    props: {
        detail: {
            type: Object,
            default: () => { }
        }
    },
    data () {
        return {
            show: true,
            // minDate: new Date(2010, 0, 1),
            // maxDate: new Date(2010, 0, 31),
        }
    },
    computed: {
        medicinalScale () {
            const { medicinalScale } = this.detail
            return medicinalScale && JSON.parse(medicinalScale)
        },
        dataList () {
            return this.detail.reminderDate || []
        },
        minDate () {
            return new Date(this.$moment(this.detail.startTime))
        },
        maxDate () {
            return new Date(this.$moment(this.detail.endTime))
        },
        patient () {
            return this.detail.patientDetail || {}
        },
        type () {
            return this.patient.pressurePersonType
        },
        pressure () {
            const { systolicPressure, diastolicPressure, measureNumber, pressureStandardScale } = this.detail
            let pressureCommon = '＜140/90mmHg'
            let baseSbp = 130
            let baseDbp = 80
            let pressureColor = '#14C9C9'
            let measureColor = '#14C9C9'
            if (this.type === 1) {
                pressureCommon = '＜130/80mmHg'
                baseSbp = 140
                baseDbp = 90
            }
            if ((systolicPressure >= baseSbp) || (diastolicPressure >= baseDbp)) {
                pressureColor = '#FA5151'
            }
            if (measureNumber < 5) {
                measureColor = '#FA5151'
            }
            return [
                { value: `${systolicPressure}/${diastolicPressure}`, color: pressureColor, name: ['本周平均血压'], label: [pressureCommon, '目标值'] },
                { value: `${measureNumber} 天`, color: measureColor, name: ['本周测量天数'], label: ['5天/周', '目标值'] },
                { value: `${parseInt(pressureStandardScale)}%`, color: '#1F2329', name: ['血压达标', '次数比例'] }
            ]
        },
        sugar () {
            const { emptyStomach, afterDinner, randomScanl } = this.detail
            let emptyStomachColor = '#15C5CE'
            let afterDinnerColor = '#15C5CE'
            let randomScanlColor = '#15C5CE'
            if (!emptyStomach) {
                emptyStomachColor = '#000000'
            } else {
                if (emptyStomach < 4.4) {
                    emptyStomachColor = '#F7BA1E'
                }
                if (emptyStomach > 7) {
                    emptyStomachColor = '#FA5151'
                }
            }

            if (!afterDinner) {
                afterDinnerColor = '#000000'
            } else {
                if (afterDinner < 4.4) {
                    afterDinnerColor = '#F7BA1E'
                }
                if (afterDinner > 10) {
                    afterDinnerColor = '#FA5151'
                }
            }

            if (!randomScanl) {
                randomScanlColor = '#000000'
            } else {
                if (randomScanl < 4.4) {
                    randomScanlColor = '#F7BA1E'
                }
                if (randomScanl > 10) {
                    randomScanlColor = '#FA5151'
                }
            }

            return [
                { value: emptyStomach, unit: 'mmol/L', color: emptyStomachColor, name: ['周平均空腹血糖'], label: ['4.4-7.0mmol/L', '目标值'] },
                { value: afterDinner, unit: 'mmol/L', color: afterDinnerColor, name: ['周平均餐后血糖'], label: ['4.4-10mmol/L', '目标值'] },
                { value: randomScanl, unit: 'mmol/L', color: randomScanlColor, name: ['周平均随机血糖'], label: ['4.4-10mmol/L', '目标值'] }
            ]
        }
    },
    methods: {
        formatter (day) {
            const month = day.date.getMonth() + 1;
            const date = day.date.getDate();
            const year = day.date.getFullYear();
            const time = `${year}-${month > 9 ? month : '0' + month}-${date > 9 ? date : '0' + date}`
            const startTime = this.$moment(this.detail.startTime).format('YYYY-MM-DD HH:mm:ss');
            const endTime = this.$moment(this.detail.endTime).format('YYYY-MM-DD HH:mm:ss');
            let index = this.dataList.findIndex(v => v.date === time)

            if (index > -1) {
                const { state } = this.dataList[index]
                if (state === 2) {
                    day.className = 'primary_calendar'
                }
                if (state === 3) {
                    day.className = 'warry_calendar'
                }
            }




            if (startTime > `${time} 00:00:00`) {
                day.className += ' none_calendar'
            }
            if (endTime < `${time} 00:00:00`) {
                day.className += ' none_calendar'
            }

            return day;
        },
    }
}
</script>
<style lang="less" scoped>
.report_compliance {
	padding-top: 28px;
	.report_calendar_header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-family: PingFangSC-Semibold;
		.title {
			font-size: 34px;
			color: #1f2329;
		}
		.tag_row {
			display: flex;
		}
		.tag {
			font-size: 24px;
			color: #ffffff;
			width: 96px;
			text-align: center;
			height: 44px;
			line-height: 44px;
			border-radius: 7px;
			margin-left: 24px;
		}
		.prmary-tag {
			background-color: @primary;
		}
		.warry-tag {
			background-color: #f7ba1e;
		}
		.error-tag {
			background-color: @danger;
		}
	}
	.report_calendar_content {
		background-color: #fafbfc;
		border-radius: 16px;
		margin-bottom: 32px;
		padding-bottom: 32px;
	}
	.calendar_text {
		font-size: 26px;
		color: #1f2329;
		vertical-align: bottom;
		text-align: center;
		span {
			font-size: 36px;
		}
	}
	// .p-20 {
	// 	padding: 20px;
	// }
	.report_calendar_remind {
		font-size: 28px;
		color: #1f2329;
		margin: 28px 0;
	}
	.base_card_label {
		font-size: 26px;
		color: #2b2f36;
	}
}
</style>
<style lang="less">
.report_compliance {
	.van-calendar {
		background-color: transparent;
	}
	.van-calendar__header-subtitle {
		font-size: 34px;
		color: #1f2329;
	}
	.van-calendar__header {
		box-shadow: none;
		.van-calendar__weekdays {
			color: @gray-9;
			font-size: 26px;
		}
	}
	.van-calendar__day {
		z-index: 2;
		color: #ffffff;
		font-size: 28px;
		font-weight: 300;
		height: 110px;
	}
	.van-calendar__day::before {
		content: '';
		width: 55px;
		height: 55px;
		border-radius: 28px;
		background-color: @danger;
		position: absolute;
		z-index: -1;
	}
	.primary_calendar::before {
		content: '';
		width: 55px;
		height: 55px;
		border-radius: 28px;
		background-color: #14c9c9;
		position: absolute;
		z-index: -1;
	}
	.warry_calendar::before {
		content: '';
		width: 55px;
		height: 55px;
		border-radius: 28px;
		background-color: #f7ba1e;
		position: absolute;
		z-index: -1;
	}
	.none_calendar {
		display: none;
	}
	.van-calendar__selected-day {
		background-color: transparent;
	}
	.van-calendar__month-title {
		display: none;
	}
	.van-calendar__month {
		margin-top: -110px;
	}
	.van-calendar__month:first-child {
		margin-top: 0;
	}
}
</style>